import React from "react";

const handleImageErrorCallBack = (
  e: React.SyntheticEvent<HTMLImageElement>,
  width: string,
  height: string,
  onClick?: () => void,
) => {
  const imgElement = e.currentTarget;
  imgElement.style.display = "none";

  const fallbackDiv = document.createElement("div");
  fallbackDiv.style.height = height;
  fallbackDiv.style.width = width;
  fallbackDiv.style.backgroundColor = "#E8E8E8";
  fallbackDiv.style.display = "flex";
  fallbackDiv.style.justifyContent = "center";
  fallbackDiv.style.alignItems = "center";
  fallbackDiv.style.color = "#B6B6B6";
  fallbackDiv.style.fontSize = "16px";
  fallbackDiv.style.fontFamily = "Mazzard";
  fallbackDiv.style.fontWeight = "400";
  fallbackDiv.style.borderRadius = "8px";

  fallbackDiv.textContent = "Unsupported Image";

  if (onClick) {
    fallbackDiv.style.cursor = "pointer";
    fallbackDiv.addEventListener("click", onClick);
  }

  imgElement.parentElement?.insertBefore(fallbackDiv, imgElement);
};

export { handleImageErrorCallBack };
